import { openConfirmDialog } from './confirmDialog';

export const ABANDON_CONFIRM_MESSAGE =
  'Des modifications non enregistrées seront perdues. Voulez-vous vraiment quitter ?';

export async function confirmAbandon(isDirty) {
  if (!isDirty) return true;
  return openConfirmDialog({
    title: 'Attention',
    message: ABANDON_CONFIRM_MESSAGE,
    confirmLabel: 'Quitter',
    cancelLabel: 'Annuler',
    icon: 'warning',
    confirmColor: 'orange',
  });
}

export async function runIfAbandonAllowed(isDirty, action) {
  if (!(await confirmAbandon(isDirty))) return;
  action();
}
